import { Instagram } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { IMAGES, CONTACT } from "@/data/site";
import { Reveal, SectionKicker } from "./Reveal";
import { BeforeAfter } from "./BeforeAfter";

export const Gallery = () => {
  const { t } = useLang();
  const g = t.gallery;

  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="py-24 sm:py-32 bg-[#050505]"
    >
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <SectionKicker>{g.kicker}</SectionKicker>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            {g.title}
          </h2>
          <p className="mt-4 text-base text-zinc-400 leading-relaxed">
            {g.subtitle}
          </p>
        </Reveal>

        <div className="mt-12 grid lg:grid-cols-2 gap-5">
          {IMAGES.beforeAfter.map((ba, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <BeforeAfter
                before={ba.before}
                after={ba.after}
                testid={`before-after-${i}`}
              />
            </Reveal>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
          {IMAGES.gallery.map((item, i) => (
            <Reveal key={i} delay={(i % 4) * 0.06}>
              <div
                data-testid={`gallery-item-${i}`}
                className="group relative overflow-hidden rounded-xl border border-white/10 aspect-square"
              >
                <img
                  src={item.src}
                  alt={g.cats[item.cat]}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <span className="absolute bottom-3 left-3 rounded-full bg-brand/90 px-3 py-1 text-[11px] font-semibold text-white translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all">
                  {g.cats[item.cat]}
                </span>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href={CONTACT.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="gallery-instagram-btn"
            className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 hover:border-brand hover:text-brand px-6 py-3 text-sm font-semibold text-white transition-colors"
          >
            <Instagram className="h-4 w-4" />
            {g.followCta} · {CONTACT.instagramHandle}
          </a>
        </div>
      </div>
    </section>
  );
};
